export const NOTIFY_EVENT_NAMES = {
    APP_READY: 'vsAppReady',
    VALIDATION_ERROR: 'vsValidationError',
    AGENTS_AVAILABLE: 'vsAgentsAvailable',
    AGENTS_UNAVAILABLE: 'vsAgentsUnavailable',
    AFTER_HOURS: 'vsAfterHours',
    FEEDBACK_SENT: 'vsFeedbackSent',
    APPOINTMENT_REQUESTED: 'vsAppointmentRequested',
    VALIDATE_SELFIE: 'vsValidateSelfie',
    SESSION_STARTED: 'vsSessionStarted',
    SESSION_STATUS_CHANGED: 'vsSessionStatusChanged',
    SESSION_SUCCESS: 'vsSessionSuccess',
    SESSION_FAILED: 'vsSessionFailed',
    SESSION_CLOSED: 'vsSessionClosed',
};

export const CLIENT_VALIDATION_ERROR_TYPE = {
    INVALID_CONNECT_TOKEN: 'invalid_connect_token',
    INVALID_OBJECT_STRUCTURE: 'invalid_object_structure',
    INVALID_TOKEN: 'invalid_token',
    INVALID_ACCOUNT: 'invalid_account',
    INVALID_GROUP: 'invalid_group',
    INVALID_SUBGROUP: 'invalid_subgroup'
};

export const EMAIL_MAX_LENGTH = 200;

export enum DynamicComponentNames {
    Layout = 'layout',
    Calling = 'calling',
    SIP = 'sip',
    WaitingForAgent = 'waiting-for-agent',
    TextChat = 'text-chat',
    FullScreenTextChat = 'full-screen-text-chat',
    AgentsUnavailable = 'agents-unavailable',
    AfterHours = 'after-hours',
    RequestAppointment = 'request-appointment',
    RequestAppointmentSubmitted = 'request-appointment-submitted',
    SessionEnded = 'session-ended',
    OnHold = 'on-hold',
    Feedback = 'feedback',
    FeedbackSubmitted = 'feedback-submitted',
    JoinSession = 'join-session',
    Avatar = 'avatar',
    FullScreenAsyncRequest = 'full-screen-async-request',
    PreSessionFlow = 'pre-session-flow',
}

export enum SipUnits {
    Icon = 'icon',
    Description= 'description',
    StartSessionButtonDefault = 'start-session-button-default',
    StartSessionButton = 'start-session-button',
    LeaveSessionButton = 'leave-session-button',
    LeaveSessionButtonDefault = 'leave-session-button-default',
    LeaveSessionButtonLabel = 'leave-session-button-label',
    MuteButton = 'mute-button',
    MuteButtonDefault = 'mute-button-default',
    RemoteStream = 'remote-stream',
}

export const SIP_DEFAULT_TEMPLATE = `
    <div class="app-sip-view">
        <div unit="${SipUnits.Icon}" class="${SipUnits.Icon}"></div>
        <div unit="${SipUnits.RemoteStream}" class="${SipUnits.RemoteStream}"></div>
        <div unit="${SipUnits.Description}" class="${SipUnits.Description}"></div>
        <div unit="${SipUnits.StartSessionButtonDefault}" class="${SipUnits.StartSessionButtonDefault}"></div>
        <div class="bottom-panel">
            <div unit="${SipUnits.MuteButtonDefault}" class="${SipUnits.MuteButtonDefault}"></div>
            <div unit="${SipUnits.LeaveSessionButtonDefault}" class="${SipUnits.LeaveSessionButtonDefault}"></div>
            <div unit="${SipUnits.LeaveSessionButtonLabel}" class="${SipUnits.LeaveSessionButtonLabel}"></div>
        </div>
        
    </div>
`;

export enum AgentsUnavailableUnits {
    AgentInfo = 'agent-info',
    AgentPreview = 'agent-preview',
    AgentName = 'agent-name',
    YourAgentLabel = 'your-agent-label',
    Description = 'description',
    Icon = 'icon',
    SetupButton = 'setup-button',
    SetupButtonDefault = 'setup-button-default',
    SetupButtonLabel = 'setup-button-label',
    SubDescription = 'sub-description',
}
export const AGENTS_UNAVAILABLE_DEFAULT_TEMPLATE = `
<div class="app-unavailable-view">
    <div unit="${AgentsUnavailableUnits.AgentInfo}" class="${AgentsUnavailableUnits.AgentInfo}">
        <div unit="${AgentsUnavailableUnits.YourAgentLabel}" class="${AgentsUnavailableUnits.YourAgentLabel}"></div>
        <div unit="${AgentsUnavailableUnits.AgentPreview}"></div>
    </div>
    <div unit="${AgentsUnavailableUnits.Icon}" replace=""></div>
    <div unit="${AgentsUnavailableUnits.Description}" class="${AgentsUnavailableUnits.Description}"></div>
    <div unit="${AgentsUnavailableUnits.SubDescription}" class="${AgentsUnavailableUnits.SubDescription}"></div>
    <div unit="${AgentsUnavailableUnits.SetupButtonDefault}"></div>
</div>
`;

export enum AfterHoursUnits {
    Title = 'title',
    Description = 'description',
    Icon = 'icon',
    NextWorkingHoursLabel = 'next-working-hours-label',
    NextWorkingHoursDate = 'next-working-hours-date'
}
export const AFTER_HOURS_DEFAULT_TEMPLATE = `
    <div class="app-after-hours-view">
        <div unit="${AfterHoursUnits.Title}" class="${AfterHoursUnits.Title}"></div>
        <div unit="${AfterHoursUnits.Description}" class="${AfterHoursUnits.Description}"></div>
        <div unit="${AfterHoursUnits.Icon}" replace=""></div>
        <div unit="${AfterHoursUnits.NextWorkingHoursLabel}" class="${AfterHoursUnits.NextWorkingHoursLabel}"></div>
        <div unit="${AfterHoursUnits.NextWorkingHoursDate}" class="${AfterHoursUnits.NextWorkingHoursDate}"></div>
    </div>
`;

export enum RequestAppointmentUnits {
    CancelButton = 'cancel-button',
    CancelButtonDefault = 'cancel-button-default',
    CaptchaContainer = 'captcha-container',
    Description = 'description',
    EmailInputContainer = 'email-input-container',
    FormDefault = 'form-default',
    Icon = 'icon',
    MessageInputContainer = 'message-input-container',
    NameInputContainer = 'name-input-container',
    PhoneInputContainer = 'phone-input-container',
    PhoneTextInputContainer = 'phone-text-input-container',
    SubmitButton = 'submit-button',
    SubmitButtonDefault = 'submit-button-default',
    Title = 'title',
}
export const REQUEST_APPOINTMENT_DEFAULT_TEMPLATE = `
    <div class="app-request-appointment-view">
        <div unit=${RequestAppointmentUnits.Icon} class="${RequestAppointmentUnits.Icon}"></div>
        <h3 unit="${RequestAppointmentUnits.Title}" class="${RequestAppointmentUnits.Title}"></h3>
        <div unit="${RequestAppointmentUnits.Description}" class="${RequestAppointmentUnits.Description}"></div>
        <div unit="${RequestAppointmentUnits.FormDefault}" replace=""></div>
    </div>
`;

export enum CallingUnits {
    YourAgentLabel = 'your-agent-label',
    AgentInfo = 'agent-info',
    AgentPreview = 'agent-preview',
    AgentName = 'agent-name',
    Icon = 'icon',
    Description = 'description',
    ReassignedToAll = 'reassigned-to-all',
    LeaveSessionButton = 'leave-session-button',
    LeaveSessionButtonDefault = 'leave-session-button-default',
    LeaveSessionButtonLabel = 'leave-session-button-label'
}

export const CALLING_DEFAULT_TEMPLATE = `
    <div class="app-calling-view">
        <div unit="${CallingUnits.AgentInfo}" class="${CallingUnits.AgentInfo}">
            <div unit="${CallingUnits.YourAgentLabel}" class="${CallingUnits.YourAgentLabel}"></div>
            <div unit="${CallingUnits.AgentPreview}" class="${CallingUnits.AgentPreview}"></div>
        </div>
        <div unit="${CallingUnits.Icon}"></div>
        <h5 unit="${CallingUnits.Description}" class="${CallingUnits.Description}"></h5>
        <div unit="${CallingUnits.ReassignedToAll}" class="${CallingUnits.ReassignedToAll}"></div>
        <div unit="${CallingUnits.LeaveSessionButtonDefault}" class="${CallingUnits.LeaveSessionButtonDefault}"></div>
        <div unit="${CallingUnits.LeaveSessionButtonLabel}" class="${CallingUnits.LeaveSessionButtonLabel}"></div>
    </div>
`;

export enum SessionEndedUnits {
    Errors = 'errors',
    Duration = 'duration',
    SessionEndedMessage = 'session-ended-message',
    YourAgentLabel = 'your-agent-label',
    AgentInfo = 'agent-info',
    AgentPreview = 'agent-preview',
    AgentName = 'agent-name',
    AddFeedbackButton = 'add-feedback-button',
    AddFeedbackButtonDefault = 'add-feedback-button-default',
}

export const SESSION_ENDED_DEFAULT_TEMPLATE = `
    <div class="app-session-ended-view">
        <div unit="${SessionEndedUnits.Errors}" class="${SessionEndedUnits.Errors}"></div>
        <div unit="${SessionEndedUnits.Duration}" class="${SessionEndedUnits.Duration}"></div>
        <div unit="${SessionEndedUnits.SessionEndedMessage}" class="${SessionEndedUnits.SessionEndedMessage}"></div>
        <div unit="${SessionEndedUnits.AddFeedbackButtonDefault}" replace=""></div>
        <div unit="${SessionEndedUnits.AgentInfo}" class="${SessionEndedUnits.AgentInfo}">
            <div unit="${SessionEndedUnits.YourAgentLabel}" class="${SessionEndedUnits.YourAgentLabel}"></div>
            <div unit="${SessionEndedUnits.AgentPreview}" class="${SessionEndedUnits.AgentPreview}"></div>
        </div>
    </div>
`;

export enum OnHoldUnits {
    Timer = 'timer',
    StatusLabel = 'status-label',
    LeaveSessionButton = 'leave-session-button',
    LeaveSessionButtonDefault = 'leave-session-button-default',
    LeaveSessionButtonLabel = 'leave-session-button-label',
    Icon = 'icon',
    Description = 'description',
    SubDescription = 'sub-description',
    YourAgentLabel = 'your-agent-label',
    AgentInfo = 'agent-info',
    AgentPreview = 'agent-preview',
    AgentName = 'agent-name',
}

export const ON_HOLD_DEFAULT_TEMPLATE = `
    <div class="app-on-hold-view">
        <div class="status-container">
            <span unit="${OnHoldUnits.StatusLabel}" replace=""></span>
            <span unit="${OnHoldUnits.Timer}" class="${OnHoldUnits.Timer}"></span>
        </div>
        <div unit="${OnHoldUnits.Icon}" class="${OnHoldUnits.Icon}"></div>
        <div unit="${OnHoldUnits.Description}" class="${OnHoldUnits.Description}"></div>
        <div unit="${OnHoldUnits.SubDescription}" class="${OnHoldUnits.SubDescription}"></div>
        <div unit="${OnHoldUnits.LeaveSessionButtonDefault}" replace=""></div>
        <div unit="${OnHoldUnits.LeaveSessionButtonLabel}" class="${OnHoldUnits.LeaveSessionButtonLabel}"></div>
        <div unit="${OnHoldUnits.AgentInfo}" class="${OnHoldUnits.AgentInfo}">
            <div unit="${OnHoldUnits.YourAgentLabel}" class="${OnHoldUnits.YourAgentLabel}"></div>
            <div unit="${OnHoldUnits.AgentPreview}"></div>
        </div>
    </div>
`;

export enum AppointmentSubmittedUnits {
    Title = 'title',
    Icon = 'icon',
    Description = 'description',
}

export const APPOINTMENT_SUBMITTED_DEFAULT_TEMPLATE = `
    <div class="app-request-appointment-submitted-view">
        <div unit="${AppointmentSubmittedUnits.Title}" class="${AppointmentSubmittedUnits.Title}"></div>
        <div unit="${AppointmentSubmittedUnits.Icon}" replace=""></div>
        <div unit="${AppointmentSubmittedUnits.Description}" class="${AppointmentSubmittedUnits.Description}"></div>
    </div>
`;

export enum WaitingForAgentWaitingForAgentUnits {
    Icon = 'icon',
    Title = 'title',
    Schedule = 'schedule',
    ScheduleDate = 'schedule-date',
    ScheduleDateLabel = 'schedule-date-label',
    LeaveSessionButton = 'leave-session-button',
    LeaveSessionButtonDefault = 'leave-session-button-default',
    LeaveSessionButtonLabel = 'leave-session-button-label'
}

export const WAITING_FOR_AGENT_DEFAULT_TEMPLATE = `
    <div class="app-waiting-for-agent-view">
        <div unit="${WaitingForAgentWaitingForAgentUnits.Icon}" replace=""></div>
        <div unit="${WaitingForAgentWaitingForAgentUnits.Title}" class="${WaitingForAgentWaitingForAgentUnits.Title}"></div>
        <div unit="${WaitingForAgentWaitingForAgentUnits.Schedule}" class="${WaitingForAgentWaitingForAgentUnits.Schedule}">
            <div
                unit="${WaitingForAgentWaitingForAgentUnits.ScheduleDateLabel}"
                class="${WaitingForAgentWaitingForAgentUnits.ScheduleDateLabel}"
            ></div>
            <div
                unit="${WaitingForAgentWaitingForAgentUnits.ScheduleDate}"
                class="${WaitingForAgentWaitingForAgentUnits.ScheduleDate}"
            ></div>
        </div>
        <div unit="${WaitingForAgentWaitingForAgentUnits.LeaveSessionButtonDefault}"></div>
        <div
            unit="${WaitingForAgentWaitingForAgentUnits.LeaveSessionButtonLabel}" 
            class="${WaitingForAgentWaitingForAgentUnits.LeaveSessionButtonLabel}"
        ></div>
    </div>
`;

export enum FullScreenTextChatUnits {
    Language = 'language',
    TextChat = 'text-chat',
    Logo = 'logo',
}

export const FULL_SCREEN_TEXT_CHAT_TEMPLATE = `
    <div class="app-full-screen-text-chat">
        <div class="header">
            <div unit="${FullScreenTextChatUnits.Logo}" class="${FullScreenTextChatUnits.Logo}"></div>
            <div unit="${FullScreenTextChatUnits.Language}" replace=""></div>
        </div>
        <div unit="${FullScreenTextChatUnits.TextChat}" replace=""></div>
    </div>
`;

export enum FullScreenAsyncRequestsUnits {
    Language = 'language',
    AsyncRequest = 'async-request',
    Logo = 'logo',
    CancelButton = 'cancel-button',
}

export const FULL_SCREEN_ASYNC_REQUEST_TEMPLATE = `
    <div class="app-full-screen-async-request">
        <div class="header">
            <div unit="${FullScreenAsyncRequestsUnits.Logo}" class="${FullScreenAsyncRequestsUnits.Logo}"></div>
            <div unit="${FullScreenAsyncRequestsUnits.Language}" replace=""></div>
        </div>
        <div unit="${FullScreenAsyncRequestsUnits.AsyncRequest}" replace=""></div>
        <div class="cancel-button-container">
            <div unit="${FullScreenAsyncRequestsUnits.CancelButton}" replace=""></div>
        </div>
    </div>
`;

export enum PreSessionFlowUnits {
    Logo = 'logo',
    Language = 'language',
    Title = 'title',
    Description = 'description',
    StepProgress = 'step-progress',
    StepName = 'step-name',
    StepPrompt = 'step-prompt',
    StepContent = 'step-content',
    FormStepTemplate = 'form-step-template',
    AsyncRequestStepTemplate = 'async-request-step-template',
    ScreenshotStepTemplate = 'screenshot-step-template',
    FileUploadStepTemplate = 'file-upload-step-template',
    LeaveSessionButton = 'leave-session-button',
    LeaveSessionButtonDefault = 'leave-session-button-default',
}

export const PRE_SESSION_FLOW_DEFAULT_TEMPLATE = `
    <div class="app-pre-session-flow-view">
        <div class="header">
            <div unit="${PreSessionFlowUnits.Logo}" class="${PreSessionFlowUnits.Logo}"></div>
            <div unit="${PreSessionFlowUnits.Language}" replace=""></div>
        </div>
        <div class="body">
            <div class="intro">
                <h2 unit="${PreSessionFlowUnits.Title}" class="${PreSessionFlowUnits.Title}"></h2>
                <p unit="${PreSessionFlowUnits.Description}" class="${PreSessionFlowUnits.Description}"></p>
                <div unit="${PreSessionFlowUnits.StepProgress}" class="${PreSessionFlowUnits.StepProgress}"></div>
            </div>
            <div class="card">
                <div unit="${PreSessionFlowUnits.StepName}" class="${PreSessionFlowUnits.StepName}"></div>
                <div unit="${PreSessionFlowUnits.StepPrompt}" class="${PreSessionFlowUnits.StepPrompt}"></div>
                <div unit="${PreSessionFlowUnits.StepContent}" class="${PreSessionFlowUnits.StepContent}" replace=""></div>
            </div>
        </div>
        <div class="leave-session-container">
            <div unit="${PreSessionFlowUnits.LeaveSessionButtonDefault}" replace=""></div>
        </div>
    </div>
    <div unit="${PreSessionFlowUnits.FormStepTemplate}" class="step form-step">
        <div unit="${PreSessionFlowUnits.StepContent}" replace=""></div>
    </div>
    <div unit="${PreSessionFlowUnits.AsyncRequestStepTemplate}" class="step async-request-step">
        <div unit="${PreSessionFlowUnits.StepContent}" replace=""></div>
    </div>
    <div unit="${PreSessionFlowUnits.ScreenshotStepTemplate}" class="step screenshot-step">
        <div unit="${PreSessionFlowUnits.StepContent}" replace=""></div>
    </div>
    <div unit="${PreSessionFlowUnits.FileUploadStepTemplate}" class="step file-upload-step">
        <div unit="${PreSessionFlowUnits.StepContent}" replace=""></div>
    </div>
`;

export enum AvatarUnits {
    Container = 'container',
    Avatar = 'avatar',
    Controls = 'controls',
    Subtitles = 'subtitles',
}

export const AVATAR_DEFAULT_TEMPLATE = `
    <div unit="${AvatarUnits.Container}" class="app-avatar-view">
        <div class="view-content">
            <div unit="${AvatarUnits.Avatar}" class="${AvatarUnits.Avatar}"></div>
        </div>
        <div unit="${AvatarUnits.Controls}" class="${AvatarUnits.Controls}"></div>
        <div unit="${AvatarUnits.Subtitles}" replace></div>
    </div>
`;

export enum LayoutUnits {
    Logo = 'logo',
    Content = 'content',
    Language = 'language',
    Copyright = 'copyright',
}

export const LAYOUT_DEFAULT_TEMPLATE = `
    <div class="app-client-dynamic-unauthorized-layout">
        <div class="header">
            <div unit="${LayoutUnits.Logo}" class="${LayoutUnits.Logo}"></div>
            <div unit="${LayoutUnits.Language}" class="${LayoutUnits.Language}"></div>
        </div>
        <div unit="${LayoutUnits.Content}" class="${LayoutUnits.Content}"></div>
        <div class="footer">
            <div unit="${LayoutUnits.Copyright}" replace=""></div>
        </div>
    </div>
`;

export enum TextChatUnits {
    Messages = 'messages',
    NoMessages = 'no-messages',
    NoMessagesDefault = 'no-messages-default',
    SystemMessageTemplate = 'system-message-template',
    ChatbotMessageTemplate = 'chatbot-message-template',
    ForeignMessageTemplate = 'foreign-message-template',
    OwnMessageTemplate = 'own-message-template',
    MessageParticipant = 'message-participant',
    MessageContent = 'message-content',
    MessageTime = 'message-time',
    InteractiveOptions = 'interactive-options',
    MessageIcon = 'message-icon',
    TypingIndicator = 'typing-indicator',
    TypingIndicatorDefault = 'typing-indicator-default',
    Form = 'form',
    FormDefault = 'form-default',
    MessageInputContainer = 'message-input-container',
    SendMessageButtonContainer = 'send-message-button-default',
    SendMessageButton = 'send-message-button',
    AttachFileButtonContainer = 'attach-file-button-default',
    AttachFileButton = 'attach-file-button',
    VoiceInputButton = 'voice-input-button',
    VoiceInputButtonDefault = 'voice-input-button-default',
    VoiceListening = 'voice-listening',
    VoiceListeningDefault = 'voice-listening-default',
}

export const TEXT_CHAT_DEFAULT_TEMPLATE = `
    <div class="app-session-text-chat">
        <div class="chat-content">
            <div unit="${TextChatUnits.Messages}" class="${TextChatUnits.Messages}"></div>
            <div unit="${TextChatUnits.NoMessagesDefault}" class="${TextChatUnits.NoMessagesDefault}"></div>
            <div unit="${TextChatUnits.TypingIndicatorDefault}" replace=""></div>
        </div>
        <div unit="${TextChatUnits.FormDefault}" replace=""></div>
    </div>
    <div unit="${TextChatUnits.SystemMessageTemplate}" class="message system">
        <div unit="${TextChatUnits.MessageIcon}" class="${TextChatUnits.MessageIcon}"></div>
        <div>
            <div unit="${TextChatUnits.MessageContent}" replace=""></div>
            <div unit="${TextChatUnits.MessageTime}" class="${TextChatUnits.MessageTime}"></div>
        </div>
    </div>
    <div unit="${TextChatUnits.ChatbotMessageTemplate}" class="message chatbot">
        <div unit="${TextChatUnits.MessageIcon}" class="${TextChatUnits.MessageIcon}"></div>
        <div>
            <div unit="${TextChatUnits.MessageContent}" replace=""></div>
            <div unit="${TextChatUnits.MessageTime}" class="${TextChatUnits.MessageTime}"></div>
        </div>
    </div>
    <div unit="${TextChatUnits.OwnMessageTemplate}" class="message own">
        <div>
            <div unit="${TextChatUnits.MessageContent}" replace=""></div>
            <div unit="${TextChatUnits.MessageTime}" class="${TextChatUnits.MessageTime}"></div>
        </div>
    </div>
    <div unit="${TextChatUnits.ForeignMessageTemplate}" class="message foreign">
        <div unit="${TextChatUnits.MessageIcon}" class="${TextChatUnits.MessageIcon}"></div>
        <div>
            <div unit="${TextChatUnits.MessageParticipant}" replace=""></div>
            <div unit="${TextChatUnits.MessageContent}" replace=""></div>
            <div unit="${TextChatUnits.MessageTime}" class="${TextChatUnits.MessageTime}"></div>
        </div>
    </div>
    <div unit="${TextChatUnits.InteractiveOptions}" replace=""></div>
`;

export enum FeedbackUnits {
    CancelButton = 'cancel-button',
    CancelButtonDefault = 'cancel-button-default',
    CommentInputContainer = 'comment-input-container',
    FormDefault = 'form-default',
    RatingInputContainer = 'rating-input-container',
    SubmitButton = 'submit-button',
    SubmitButtonDefault = 'submit-button-default',
    Title = 'title',
}

export const FEEDBACK_DEFAULT_TEMPLATE = `
    <div class="app-feedback-view">
        <h3 unit="${FeedbackUnits.Title}" class="${FeedbackUnits.Title}"></h3>
        <div unit="${FeedbackUnits.FormDefault}" class="${FeedbackUnits.FormDefault}"></div>
    </div>
`;

export enum FeedbackSubmittedUnits {
    Title = 'title',
    Icon = 'icon',
    Description = 'description',
}

export const FEEDBACK_SUBMITTED_DEFAULT_TEMPLATE = `
    <div class="app-feedback-submitted-view">
        <div unit="${FeedbackSubmittedUnits.Title}" class="${FeedbackSubmittedUnits.Title}"></div>
        <div unit="${FeedbackSubmittedUnits.Icon}" replace=""></div>
        <div unit="${FeedbackSubmittedUnits.Description}" class="${FeedbackSubmittedUnits.Description}"></div>
    </div>
`;

export enum JoinSessionUnits {
    Icon = 'icon',
    Title = 'title',
    Description = 'description',
    Errors = 'errors',
    FormDefault = 'form-default',
    CodeInputContainer = 'code-input-container',
    PinInputContainer = 'pin-input-container',
    SubmitButton = 'submit-button',
    SubmitButtonDefault = 'submit-button-default'
}

export const JOIN_SESSION_DEFAULT_TEMPLATE = `
    <div class="app-join-session-view">
        <div unit="${JoinSessionUnits.Icon}"></div>
        <div class="card">
            <div unit="${JoinSessionUnits.Title}" class="${JoinSessionUnits.Title}"></div>
            <div unit="${JoinSessionUnits.Errors}" class="${JoinSessionUnits.Errors}"></div>
            <div unit="${JoinSessionUnits.Description}" class="${JoinSessionUnits.Description}"></div>
            <div unit="${JoinSessionUnits.FormDefault}"></div>
        </div>
    </div>
`;

export const ClientDynamicComponentsConfig = {
    [DynamicComponentNames.Layout]: {
        units: LayoutUnits,
        defaultTemplate: LAYOUT_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.Calling]: {
        units: CallingUnits,
        defaultTemplate: CALLING_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.Avatar]: {
        units: AvatarUnits,
        defaultTemplate: AVATAR_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.FullScreenTextChat]: {
        units: FullScreenTextChatUnits,
        defaultTemplate: FULL_SCREEN_TEXT_CHAT_TEMPLATE
    },
    [DynamicComponentNames.OnHold]: {
        units: OnHoldUnits,
        defaultTemplate: ON_HOLD_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.WaitingForAgent]: {
        units: WaitingForAgentWaitingForAgentUnits,
        defaultTemplate: WAITING_FOR_AGENT_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.AgentsUnavailable]: {
        units: AgentsUnavailableUnits,
        defaultTemplate: AGENTS_UNAVAILABLE_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.AfterHours]: {
        units: AfterHoursUnits,
        defaultTemplate: AFTER_HOURS_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.RequestAppointment]: {
        units: RequestAppointmentUnits,
        defaultTemplate: REQUEST_APPOINTMENT_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.RequestAppointmentSubmitted]: {
        units: AppointmentSubmittedUnits,
        defaultTemplate: APPOINTMENT_SUBMITTED_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.SessionEnded]: {
        units: SessionEndedUnits,
        defaultTemplate: SESSION_ENDED_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.TextChat]: {
        units: TextChatUnits,
        defaultTemplate: TEXT_CHAT_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.Feedback]: {
        units: FeedbackUnits,
        defaultTemplate: FEEDBACK_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.FeedbackSubmitted]: {
        units: FeedbackSubmittedUnits,
        defaultTemplate: FEEDBACK_SUBMITTED_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.JoinSession]: {
        units: JoinSessionUnits,
        defaultTemplate: JOIN_SESSION_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.SIP]: {
        units: SipUnits,
        defaultTemplate: SIP_DEFAULT_TEMPLATE
    },
    [DynamicComponentNames.FullScreenAsyncRequest]: {
        units: FullScreenAsyncRequestsUnits,
        defaultTemplate: FULL_SCREEN_ASYNC_REQUEST_TEMPLATE
    },
    [DynamicComponentNames.PreSessionFlow]: {
        units: PreSessionFlowUnits,
        defaultTemplate: PRE_SESSION_FLOW_DEFAULT_TEMPLATE
    },
};
